import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import Header from "../components/Header";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";

export default function Matrix() {
  const [levels, setLevels] = useState(null);

  useEffect(() => {
    api.get("/matrix")
      .then((r) => setLevels(r.data.levels))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);

  if (!levels) return <div className="pt-28 text-center text-muted-foreground">Carregando matriz...</div>;

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-24 pb-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Matriz</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold mt-1">Sua <span className="gold-text">rede completa</span></h1>
        <p className="mt-2 text-muted-foreground max-w-2xl">
          Visualize as posições ocupadas em cada nível. As bonificações são calculadas automaticamente pelo derramamento
          na matriz forçada 5x4 (5 posições por nível, bonificação do 1º ao 4º nível).
        </p>

        <Tabs defaultValue="1" className="mt-8">
          <TabsList className="flex flex-wrap h-auto" data-testid="matrix-tabs">
            {levels.map((l) => (
              <TabsTrigger key={l.level} value={String(l.level)} data-testid={`matrix-tab-${l.level}`}>
                Nível {l.level} · {l.filled}/{l.capacity.toLocaleString("pt-BR")}
              </TabsTrigger>
            ))}
          </TabsList>

          {levels.map((l) => (
            <TabsContent key={l.level} value={String(l.level)} className="mt-6">
              <Card className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <div className="font-display text-xl font-bold">Nível {l.level}</div>
                    <div className="text-xs text-muted-foreground">{l.capacity.toLocaleString("pt-BR")} posições possíveis</div>
                  </div>
                  <Badge className="gold-btn">{l.filled} preenchidas</Badge>
                </div>

                {l.positions.length === 0 ? (
                  <p className="text-sm text-muted-foreground">Ainda não há posições preenchidas neste nível.</p>
                ) : (
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
                    {l.positions.map((p) => (
                      <div key={p.id} className="p-3 rounded-xl gold-border" data-testid={`matrix-node-l${l.level}-${p.id}`}>
                        <div className="font-medium text-sm truncate">{p.name}</div>
                        <div className="text-[10px] uppercase tracking-wider text-muted-foreground mt-1">{p.plan_label}</div>
                        <div className="text-[10px] mt-1">
                          <span className={p.status === "active" ? "text-emerald-500" : "text-rose-500"}>
                            ● {p.status === "active" ? "Ativo" : "Inativo"}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </Card>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
